<template>
  <div class="list">
    <p class="total mb15">
      <span v-html="locale.coupon_total"></span>
      <span class="count">{{list.length}}</span>
    </p>
    <CouponItem
      v-for="item in list"
      :key="item.id"
      :lang="lang"
      :item="item"
      :couponKey="couponKey"
      :locale="locale" />
  </div>
</template>

<script>
import CouponItem from '@/components/Coupon/CouponItem.vue'

export default {
  name: 'CouponList',
  props: [
    'lang',
    'list',
    'couponKey',
    'locale'
  ],
  components: {
    CouponItem
  }
}
</script>

<style lang="scss" scoped>
.total {
  font-size: 0.9em;
  .count {
    display: inline-block;
    margin-left: 0.3em;
    padding: 0 0.5em;
    font-size: 0.9em;
    font-weight: 700;
    color: $color-white;
    line-height: 1.3;
    border-radius: 50px;
    background-color: $color-green;
  }
}
</style>
